import { createBrowserHistory } from 'history';
import store from 'state/store/configureStore';
import { routeChanged } from 'state/actions';

const history = createBrowserHistory();

// Listen for changes to the current location.
history.listen((location, action) => {
  if (action === 'PUSH')
    store.dispatch(
      routeChanged({
        location,
        action,
        history
      })
    );
});

export default history;
